import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { useColumnHeaderContext } from '../hooks/useColumnHeaderContext';
import { ColumnHeaderMenuTop } from './ColumnHeaderMenuTop';
import { ColumnHeaderMenuList } from './ColumnHeaderMenuList';

interface ColumnHeaderMenuProps {
  emptyStateMessage?: string;
}

export const ColumnHeaderMenu: React.FC<ColumnHeaderMenuProps> = ({ emptyStateMessage = 'No values found' }) => {
  const { filter, items, search } = useColumnHeaderContext();

  return (
    <Box p={1} display='flex' flexDirection='column'>
      {items.isLoading && search?.term === '' ? (
        <div className='flex items-center justify-center py-24 px-12'>
          <CircularProgress size={24} />
        </div>
      ) : (
        <>
          {/* Top Section: Sort + Search */}
          <ColumnHeaderMenuTop />

          {(items?.items?.length > 0 || (search?.term !== '' && items?.items?.length === 0)) && (
            <>
              <ColumnHeaderMenuList emptyStateMessage={emptyStateMessage} />

              {/* Apply Button */}
              <div className='-mb-8 -mx-8 p-16 rounded-b-8 bg-neutral-10 border-t border-neutral-20'>
                <Button
                  variant='contained'
                  fullWidth
                  onClick={filter.onApply}
                  disabled={filter.selectedValues.length === 0}
                  sx={{
                    '&.Mui-disabled': {
                      backgroundColor: '#BFBFBF',
                      color: '#FFFFFF',
                      cursor: 'not-allowed',
                      opacity: 0.9,
                    },
                  }}
                >
                  Apply
                </Button>
              </div>
            </>
          )}
        </>
      )}
    </Box>
  );
};
